// Silver Token e Gold Token no imbuement (pedido do Arthur, 17/10): em vez dos itens de criatura, o imbuement pode ser
// pago com tokens (o gold do banco continua). Silver Token vale para os níveis 1 e 2 (Basic e Intricate) e Gold Token para o
// nível 3 (Powerful). Os tokens caem de todos os bosses, para cada jogador que ajudou (5%+ do dano), na Noxara Store Box.
//
// Conta do balanceamento (meta: um jogador free que faz a rotação do dia aplica pelo menos 2 imbuements no set):
//   rotação free = 10 tentativas de boss por dia (BOSS_ATTEMPTS.free).
//   Bane:    1 silver garantido + 50% de +1 (média 1,5)  · 25% de 1 gold
//   Archfoe: 2 silver garantidos + 50% de +1 (média 2,5) · 1 gold garantido + 25% de +1 (média 1,25)
//   Nemesis: 3 silver garantidos + 50% de +1 (média 3,5) · 2 gold garantidos + 25% de +1 (média 2,25)
//   - jogador baixo (só Banes): 10 a 20 silver por dia (média 15) → no mínimo 2 Intricate (4 silver cada) todo dia;
//     e ~2,5 gold por dia → 1 Powerful a cada 2 dias.
//   - jogador alto (Archfoes): no mínimo 10 gold por dia → 2 Powerful (5 gold cada) garantidos, mais ~25 silver de sobra.
//   - Nemesis: 20+ gold por dia → 4 Powerful.
// O imbuement dura 20 h de caça, então a rotação diária mantém 2 engastes sempre ativos só com tokens; os demais
// engastes seguem pelos itens de criatura (ou pelos tokens comprados de outros jogadores no Mercado).
import type { BossCat } from './bosses.js';

export const SILVER_TOKEN = 22516;
export const GOLD_TOKEN = 22721;
/** tokens que substituem os itens de criatura de cada nível de imbuement: [item, quantidade] */
export const IMBUE_TOKEN_COST: Record<number, [number, number]> = { 1: [SILVER_TOKEN, 2], 2: [SILVER_TOKEN, 4], 3: [GOLD_TOKEN, 5] };
/** drop por boss: [garantidos, chance (%) de +1] */
export const BOSS_TOKENS: Record<BossCat, { silver: [number, number]; gold: [number, number] }> = {
  bane: { silver: [1, 50], gold: [0, 25] },
  archfoe: { silver: [2, 50], gold: [1, 25] },
  nemesis: { silver: [3, 50], gold: [2, 25] },
};
export function rollBossTokens(cat: BossCat, rnd: () => number = Math.random): { silver: number; gold: number } {
  const t = BOSS_TOKENS[cat];
  return { silver: t.silver[0] + (rnd() * 100 < t.silver[1] ? 1 : 0), gold: t.gold[0] + (rnd() * 100 < t.gold[1] ? 1 : 0) };
}
